import { useTranslation } from 'react-i18next';
import NavBar from '../../components/NavBar';
import { RepositoryContext } from '../../store/RepositoryProvider';
import API from '../../server/api';
import { useCallback, useContext, useEffect, useState } from 'react';
import ReportParams from '../../models/report/ReportParams';
import Ticket from '../order/ticket';
import OrderDetails from '../../models/order/OrderDetails';
import log from '../../utils/logger';
import List from '../../components/List';
import DayPicker, { DAY_PICKER_MODE } from '../../components/DayPicker';

const Tickets = () => {
  const {t} = useTranslation(['common', 'ticket']);

  const repository = useContext(RepositoryContext);

  const [tickets, setTickets] = useState([]);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleApplyRangeModal = useCallback((range) => {
    setStartDate(range.from);
    setEndDate(range.to || range.from);
  }, []);

  const loadTickets = useCallback(async () => {
    try {
      let _tickets = await repository.report(API.user.tickets, new ReportParams(), OrderDetails);
      // {
      //   fromDate: DateFormat.Request({ date: startDate }),
      //   toDate: DateFormat.Request({ date: endDate })
      // }
      setTickets(_tickets.rows);
    } catch(e) {
      log.error(e);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    loadTickets();
  }, [startDate, endDate]);

  useEffect(() => {
    setStartDate(new Date());
    setEndDate(new Date());
  }, []);

  return (
    <div className="trip-app">
      <NavBar title={t('ticket:ticket.title')} />
      <div className="trip-app-body">
        <div className="header-line">{t('ticket:ticket.period')}</div>
        <div className="input">
          <DayPicker.Input mode={DAY_PICKER_MODE.RANGE} selected={{from: startDate, to: endDate}} onChange={handleApplyRangeModal}/>
        </div>
        <List>
          {tickets.map((ticket) => (
            <List.Row key={ticket.id} delim={true}>
              <Ticket
                order={ticket.id}
                number={ticket.number}
                excursion={ticket.excursion}
                date={ticket.date}
                schedule={ticket.schedule}
                seats={ticket.seats}
                transports={ticket.transports}
                paidAmount={ticket.paidAmount}
                paymentMethod={ticket.paymentMethod}
                status={ticket.status}
              />
            </List.Row>
          ))}
        </List>
      </div>
    </div>
  )
}

export default Tickets;